import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const InboundList = lazy(() => import('./pages/InboundList'));
const InboundByPackage = lazy(() => import('./pages/InboundByPackage'));
const CreateInbound = lazy(() => import('./pages/CreateInbound'));
const InboundDetails = lazy(() => import('./pages/InboundDetails'));
const InboundShipmentDetail = lazy(() => import('./pages/InboundShipmentDetail'));

const inboundRoutes: RouteObject[] = [
  {
    index: true,
    element: <InboundList />,
  },
  {
    path: 'by-package',
    element: <InboundByPackage />,
  },
  {
    path: 'create',
    element: <CreateInbound />,
  },
  {
    path: 'process/:shipmentBatchId',
    element: <CreateInbound />,
  },
  {
    path: 'shipment/:shipmentBatchId',
    element: <InboundShipmentDetail />,
  },
  {
    path: ':id',
    element: <InboundDetails />,
  },
];

export default inboundRoutes;
